import { TreatmentOverviewHome } from "@/components/consultation/tabs/treatment-overview";

const TreatmentOverview = () => {
  return (
    <div className="h-full overflow-hidden p-2 sm:p-3">
      <TreatmentOverviewHome />
    </div>
  );
};

export default TreatmentOverview;
